"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2,3.15v4h.21a.46.46,0,0,0,.18,0A.38.38,0,0,0,2.56,7L3.75,5.49a.55.55,0,0,1,.17-.15.47.47,0,0,1,.23-.05H5.2L3.72,7.06a1.23,1.23,0,0,1-.34.32.89.89,0,0,1,.17.16l.15.2,1.59,2.32h-1A.56.56,0,0,1,4,10a.36.36,0,0,1-.16-.16L2.63,8a.35.35,0,0,0-.13-.14.53.53,0,0,0-.21,0H2v2.19H.88V3.15Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.85,10.06V5.29h.7a.28.28,0,0,1,.29.21l.07.35a2.61,2.61,0,0,1,.26-.26,1.64,1.64,0,0,1,.29-.2,1.58,1.58,0,0,1,.33-.13,1.49,1.49,0,0,1,.39,0A1.11,1.11,0,0,1,9,5.46a1.47,1.47,0,0,1,.44.65,1.45,1.45,0,0,1,.28-.41A1.55,1.55,0,0,1,10,5.42a1.69,1.69,0,0,1,.43-.16,2,2,0,0,1,.45-.05,1.9,1.9,0,0,1,.7.12,1.34,1.34,0,0,1,.52.35,1.57,1.57,0,0,1,.32.57,2.48,2.48,0,0,1,.11.77v3H11.41V7a1,1,0,0,0-.2-.69.73.73,0,0,0-.59-.23.88.88,0,0,0-.33.06.77.77,0,0,0-.44.46,1.12,1.12,0,0,0-.07.4v3H8.63V7a1,1,0,0,0-.19-.7.72.72,0,0,0-.57-.22.93.93,0,0,0-.47.12,1.57,1.57,0,0,0-.4.34v3.5Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.82,19v.69h-3V19h1.1V15.87q0-.19,0-.39l-.78.65A.32.32,0,0,1,3,16.2H2.89l-.1,0-.07-.06-.29-.4,1.65-1.4h.76V19Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.77,19v.69h-3V19h1.1V15.87q0-.19,0-.39l-.78.65a.32.32,0,0,1-.13.07h-.12l-.1,0-.07-.06-.29-.4L12,14.3h.76V19Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.36,14.19v.69h-3v-.69h1.1V11.61c0-.12.92.12.92.12v2.47Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.81,21.2a3.46,3.46,0,0,1-.11,1.08L18,22.3a3.66,3.66,0,0,1-.12-1.1A4.48,4.48,0,0,1,18,20a2.52,2.52,0,0,1,.42-.86A1.69,1.69,0,0,1,19,18.6a1.85,1.85,0,0,1,.78-.17,1.88,1.88,0,0,1,.79.17,1.7,1.7,0,0,1,.63.51,2.52,2.52,0,0,1,.42.86A4.42,4.42,0,0,1,21.81,21.2Zm-1,0a4.59,4.59,0,0,0-.09-1,2,2,0,0,0-.23-.61.84.84,0,0,0-.33-.32.87.87,0,0,0-.39-.09.85.85,0,0,0-.38.09.83.83,0,0,0-.33.32,2,2,0,0,0-.23.61,5.67,5.67,0,0,0,0,1.95c.06.26,1.83.26,1.89,0A4.58,4.58,0,0,0,20.86,21.2Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.91,22.48H.5V11.33H7.91ZM1.28,21.7H7.13V12.11H1.28Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.7,22.48H8.3V11.33H15.7ZM9.08,21.7h5.85V12.11H9.08Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.5,22.48H16.09V11.33H23.5Zm-6.63-.78h5.85V12.11H16.87Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.14,3.07a2.82,2.82,0,0,1-1.07,1.55.18.18,0,0,1-.13,0,1.41,1.41,0,0,0-1,.16,2,2,0,0,1,.27.65.5.5,0,0,0,.31-.05.18.18,0,0,1,.21,0c.45.45-.13,1-.48,1.4l-.18.2,0,0a.47.47,0,0,1,.2.33.42.42,0,0,1-.14.31,1.89,1.89,0,0,1-.5.36c-.05.62-.51,1-1.28,1-.36,0-.73-.91-.73-1.1a.8.8,0,0,1,.11-.36.55.55,0,0,0,.07-.19A1.41,1.41,0,0,0,17.55,7a.18.18,0,0,1-.05-.13.44.44,0,0,0-.08-.32c-.09-.09-.31-.07-.54-.06h-.29c-.58,0-.73-.6-.73-.92,0-.06,0-1.44,1.06-1.65a1.21,1.21,0,0,1,1,.09.4.4,0,0,1,.13.18c.19.14.54.06.85,0l.29-.06a2.72,2.72,0,0,0,0-.74.71.71,0,0,1-.62,0,.66.66,0,0,1-.32-.54c0-.53,1-.94,1.67-1.16a4.42,4.42,0,1,0,2.24,1.41Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;